import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
import { ProtectedRoleTecnical } from "../hooks/roles/ProtectedRoleTecnical";

const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleTareaSimple = React.lazy(
  () =>
    import(
      "../components/task/tecnical/tareaDetalleTareaSimple/tarea-detalle-tarea-simple"
    )
);
export function tareaDetalleTareaSimple() {
  return (
    <Route
      path="/tarea-detalle-tarea-simple"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleTecnical>
              <LazySuspense>
                <TareaDetalleTareaSimple />
              </LazySuspense>
            </ProtectedRoleTecnical>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
